var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/ic-eva:arrow-ios-back-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "primary-shape",
    d: "M9.71978 12.6667C9.51806 12.6673 9.32687 12.5767 9.19978 12.42L5.97978 8.41999C5.77757 8.17399 5.77757 7.81933 5.97978 7.57332L9.31312 3.57332C9.54876 3.28982 9.96961 3.25102 10.2531 3.48666C10.5366 3.7223 10.5754 4.14315 10.3398 4.42666L7.35978 7.99999L10.2398 11.5733C10.4062 11.7731 10.4413 12.0515 10.3296 12.2864C10.2179 12.5212 9.97983 12.6697 9.71978 12.6667Z",
    fill: "#065EEA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.53b4aa6e80bd43eca3f7bb50e2e80b29.svg";
export { ForwardRef as ReactComponent };